import { isText } from 'domhandler';
export function processTextNode(node) {
    return isText(node) ? node.data : null;
}
//# sourceMappingURL=ProcessTextNode.js.map